module.exports = __webpack_public_path__ + "img/how-work.83f9834d.png";